import { doc, getDoc, type Firestore } from 'firebase/firestore';
import type { PublicAgendaRepository, PublicAgendaSnapshot } from '@nx/domain';
import { mapPublicAgendaDoc, snapshotData } from './firestoreMappers';

const PUBLIC_AGENDAS = 'publicAgendas';

export class FirebasePublicAgendaRepository implements PublicAgendaRepository {
  constructor(private readonly db: Firestore) {}

  async getByToken(token: string): Promise<PublicAgendaSnapshot | null> {
    const snap = await getDoc(doc(this.db, PUBLIC_AGENDAS, token));
    if (!snap.exists()) return null;
    const data = snapshotData(snap);
    return mapPublicAgendaDoc({ ...data, token: snap.id });
  }
}
